import { api } from '../utils'

export const getSettings = () => api.get('/settings').then(({ data }) => data)

export const saveSettings = (params = {}) =>
  api
    .patch('/settings', params)
    .then(({ data, errors }) => ({ ...data, errors }))
